import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useHydratedTranslation = () => {
  const { t, ...rest } = useTranslation();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  function tHydrated(key, options = {}) {
    return mounted ? t(key, options) : t(key, { ...options, lng: 'en' });
  }

  return { t: tHydrated, mounted, ...rest };
};
